"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
require("./SelectPlan.scss");
const snap_ui_1 = require("@teamsnap/snap-ui");
const icons_1 = require("components/common/icons");
const api_1 = require("core/api");
const useExperiments_1 = require("hooks/useExperiments");
const useAmpli_1 = require("src/hooks/useAmpli");
const useNavigation_1 = require("src/hooks/useNavigation");
const useFeatureFlag_1 = require("../../../hooks/useFeatureFlag");
const useSelectPlan_1 = require("./useSelectPlan");
const SelectPlan = () => {
    const { products, groupItems, setFrequency, teamId, choosePlan, isProcessing, selectedId, isTrial, basicAvailable, loaded, checkoutContext, } = (0, useSelectPlan_1.useSelectPlan)();
    const { navigate } = (0, useNavigation_1.useNavigation)();
    const experiments = (0, useExperiments_1.useExperiments)();
    const newPricingPage = experiments[useExperiments_1.EXPERIMENT_IDS.NEW_PRICING_PAGE];
    const forwardToNewPricingPage = newPricingPage
        ? Boolean(newPricingPage?.isEnabled && newPricingPage?.hasAccess)
        : false;
    const { freeTeamSelected, pricingViewed } = (0, useAmpli_1.useAmpli)();
    (0, useFeatureFlag_1.useFeatureFlag)('teamPlan');
    React.useEffect(() => {
        if (forwardToNewPricingPage && teamId) {
            const urlParams = new URLSearchParams(window.location.search);
            navigate.v1TeamPlanNew(teamId, undefined, urlParams.toString());
        }
    }, [forwardToNewPricingPage, teamId, navigate]);
    React.useEffect(() => {
        if (loaded && !forwardToNewPricingPage) {
            pricingViewed(!!isTrial, basicAvailable);
        }
    }, [loaded, forwardToNewPricingPage, pricingViewed, isTrial, basicAvailable]);
    const onChooseFreePlan = () => {
        freeTeamSelected();
        // @ts-ignore
        if (window?.webkit?.messageHandlers?.webCheckoutObserver) {
            // @ts-ignore
            window.webkit.messageHandlers.webCheckoutObserver.postMessage({
                event: 'flowCancelled',
            });
            return;
        }
        if (checkoutContext === api_1.CheckoutContext.ONBOARDING) {
            navigate.chooseFreePlan(teamId);
        }
        else {
            navigate.classicTeamBilling();
        }
    };
    if (forwardToNewPricingPage) {
        return null;
    }
    return (React.createElement("div", { className: "SelectPlan" },
        React.createElement("div", { className: "sui-flex sui-justify-center sui-my-3" },
            React.createElement("div", { className: "d:sui-w-1/3" }),
            React.createElement("div", { className: "d:sui-w-1/3 sui-flex sui-justify-center" }, groupItems && (React.createElement(snap_ui_1.SegmentedControl, { ariaLabel: "Choose between Monthly and Annually", defaultValue: 'year', items: groupItems, onChange: setFrequency }))),
            React.createElement("div", { className: "d:sui-w-1/3 sui-flex sui-justify-end" },
                React.createElement(snap_ui_1.LabelButton, { "data-testid": "free-plan-button-desktop", className: "sui-hidden d:sui-inline-flex", labelText: "Get started with our free version", variantType: "tertiary", icon: "chevron_right", iconPosition: "right", onClick: onChooseFreePlan }))),
        React.createElement("div", { className: "d:sui-mb-3 sui-px-2" },
            React.createElement("div", { className: "heading sui-mb-0.5" }, "Choose a plan that best fits your team"),
            isTrial && (React.createElement("div", { className: "body", "data-testid": "trial-dialog" }, "Every plan starts with a free 7-day trial."))),
        React.createElement("div", { className: "plan-group d:sui-flex" }, products.map((product) => (React.createElement("div", { className: `plan ${product.highlighted ? 'highlighted' : ''}  sui-p-7`, key: product.priceId, "data-testid": `plan-${product.dataId}` },
            product.badgeLabel && (React.createElement("div", { className: "sui-hidden d:sui-inline-block" },
                React.createElement(snap_ui_1.Status, { state: "success", "data-testid": "badge-label" }, product.badgeLabel))),
            React.createElement("div", { className: "sui-flex sui-justify-between sui-mt-3 sui-mb-1 sui-align-left" },
                React.createElement("div", { className: "plan-title sui-text-left" }, product.title),
                product.badgeLabel && (React.createElement("div", { className: "d:sui-hidden sui-whitespace-nowrap" },
                    React.createElement(snap_ui_1.Status, { state: "success", "data-testid": "badge-label-mobile" }, product.badgeLabel)))),
            React.createElement("div", { className: "plan-description sui-mb-4" }, product.description),
            React.createElement("div", { className: "gap" }),
            React.createElement("div", { className: "sui-flex sui-justify-start sui-items-center sui-mt-3 sui-mb-4" },
                React.createElement("div", { className: "price" },
                    "$",
                    product.priceInCents / 100),
                React.createElement("div", { className: "price-small sui-ml-2", style: {
                        // Set max-width to force wrapping, and based on USD presence
                        maxWidth: product.priceIntervalLabel?.includes('USD') ? '3.6rem' : '2.5rem',
                    } }, product.priceIntervalLabel)),
            React.createElement(snap_ui_1.LabelButton, { "data-testid": "start-trial-button", className: "sui-mb-3 sui-w-full", onClick: () => choosePlan(product.priceId), labelText: product.ctaLabel, disabled: isProcessing && selectedId !== product.priceId, loading: isProcessing && selectedId === product.priceId }),
            React.createElement("div", { className: "features-text sui-mb-2" }, "This includes:"),
            React.createElement("ul", { className: "features-list" }, product.features?.map((feature, i) => (React.createElement("li", { key: i },
                React.createElement(icons_1.CheckRound, null),
                feature)))))))),
        React.createElement(snap_ui_1.LabelButton, { "data-testid": "free-plan-button-mobile", className: "sui-w-full d:sui-hidden sui-mb-3", labelText: "Get started with our free version", variantType: "tertiary", icon: "chevron_right", iconPosition: "right", onClick: onChooseFreePlan })));
};
exports.default = SelectPlan;
